import clsx from 'clsx';
import { memo } from 'react';

import { SharedStatusBadgeProps } from '../../types/SharedStatusBadgeProps';
import { Text } from '../Text/Text';
import './StatusBadge.css';

export const StatusBadge = memo(
  ({ status = 'neutral', text }: SharedStatusBadgeProps) => {
    return (
      <div className={clsx('eds-status-badge', `eds-styles--status-${status}`)}>
        <Text truncate={1} variant="body-semi-s">
          {text}
        </Text>
      </div>
    );
  },
);

StatusBadge.displayName = 'StatusBadge';
